/** @jsx jsx */
import PropTypes from 'prop-types'
import { jsx } from '@emotion/core'

import Mobile1Up from './Mobile1Up'
import Mobile2Up from './Mobile2Up'
import Mobile3Up from './Mobile3Up'
import Mobile1UpBottom from './Mobile1UpBottom'
import Mobile4Up from './Mobile4Up'

export const WORK_SHOWCASE_LAYOUT_MOBILE_1UP = 'WORK_SHOWCASE_LAYOUT_MOBILE_1UP'
export const WORK_SHOWCASE_LAYOUT_MOBILE_1UP_BOTTOM =
	'WORK_SHOWCASE_LAYOUT_MOBILE_1UP_BOTTOM'
export const WORK_SHOWCASE_LAYOUT_MOBILE_2UP = 'WORK_SHOWCASE_LAYOUT_MOBILE_2UP'
export const WORK_SHOWCASE_LAYOUT_MOBILE_3UP = 'WORK_SHOWCASE_LAYOUT_MOBILE_3UP'
export const WORK_SHOWCASE_LAYOUT_MOBILE_4UP = 'WORK_SHOWCASE_LAYOUT_MOBILE_4UP'

const layoutTags = {
	[WORK_SHOWCASE_LAYOUT_MOBILE_1UP]: Mobile1Up,
	[WORK_SHOWCASE_LAYOUT_MOBILE_1UP_BOTTOM]: Mobile1UpBottom,
	[WORK_SHOWCASE_LAYOUT_MOBILE_2UP]: Mobile2Up,
	[WORK_SHOWCASE_LAYOUT_MOBILE_3UP]: Mobile3Up,
	[WORK_SHOWCASE_LAYOUT_MOBILE_4UP]: Mobile4Up,
}

const propTypes = {
	items: PropTypes.arrayOf(
		PropTypes.shape({
			src: PropTypes.string.isRequired,
			alt: PropTypes.string,
		})
	),
	showChrome: PropTypes.bool,
	layout: PropTypes.oneOf(Object.keys(layoutTags)),
}

const defaultProps = {
	items: [],
	showChrome: true,
	layout: WORK_SHOWCASE_LAYOUT_MOBILE_1UP,
}

const WorkShowcase = ({ layout, items, showChrome }) => {
	const Tag = layoutTags[layout] || Mobile1Up

	return (
		<div
			css={{
				display: 'flex',
				justifyContent: 'center',
			}}
		>
			<Tag items={items} showChrome={showChrome} />
		</div>
	)
}

WorkShowcase.propTypes = propTypes
WorkShowcase.defaultProps = defaultProps

export default WorkShowcase
